import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";

import Home from "./pages/Home";
import Courses from "./pages/Courses";
import Tournaments from "./pages/Tournaments";
import ResultDetails from "./pages/ResultDetails";
import TournamentDetails from "./pages/TournamentDetails";
import Login from "./pages/Login";
import About from "./pages/About";
import Ranking from "./pages/Ranking"

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Scroll from "./components/Scroll";
import ProtectedRoute from "./components/ProtectedRoute";
import ModulePage from "./components/ModulePage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ContactUs from "./components/ContactUs";

/* 🔽 ADMIN */
import AdminRoute from "./components/AdminRoute";
import AdminDashboard from "./pages/AdminDashboard";
import AddPuzzle from "./pages/AddPuzzle";
import AlterTournament from "./pages/AlterTournament"
import AddNotification from "./components/AddNotification";

function AppContent() {
  const location = useLocation();
  const hideNavbar = location.pathname === "/login";

  return (
    <>
      {!hideNavbar && <Navbar />}
      <Scroll />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/login" element={<Login />} />

        <Route
          path="/courses"
          element={
            <ProtectedRoute>
              <Courses />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ranking"
          element={
            <ProtectedRoute>
              <Ranking />
            </ProtectedRoute>
          }
        />

        <Route
          path="/tournaments"
          element={
            <ProtectedRoute>
              <Tournaments />
            </ProtectedRoute>
          }
        />

        <Route
          path="/results/:resultID"
          element={
            <ProtectedRoute>
              <ResultDetails />
            </ProtectedRoute>
          }
        />

        <Route
          path="/tournaments/:tournamentID"
          element={
            <ProtectedRoute>
              <TournamentDetails />
            </ProtectedRoute>
          }
        />

        <Route
          path="/courses/:level/:moduleId"
          element={
            <ProtectedRoute>
              <ModulePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/privacy-policy"
          element={
            <ProtectedRoute>
              <PrivacyPolicy />
            </ProtectedRoute>
          }
        />
        <Route
          path="/contact-us"
          element={
            <ProtectedRoute>
              <ContactUs />
            </ProtectedRoute>
          }
        />

        {/* 👑 ADMIN ROUTES */}
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/add-puzzle"
          element={
            <AdminRoute>
              <AddPuzzle />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/alter-tournament"
          element={
            <AdminRoute>
              <AlterTournament />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/add-notification"
          element={
            <AdminRoute>
              <AddNotification />
            </AdminRoute>
          }
        />
  
      </Routes>

      {!hideNavbar && <Footer />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
